export const assessmentTemplate = [
  {
    _id: "IndependentFunction",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Akrogh",
      createdDate: "2022-03-04T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "IndependentFunction",
      omniTypeVersion: 1,
      title: "Independent Function",
      purpose: "Cognitive Functionality",
      description:
        "The Independent Function Scale, or IFS, is a short survey assess your level of independent function in and outside your home.",
      duration: "About 5 minutes",
      directions:
        "Please select the best answer for each of the following concerns. Remember, if it's helpful, you can use someone else’s input. Press 'start' to begin your assessment.",
      attribution: "Dr. David Greeley, MD, FAAN, Northwest Neurological, PLLC",
      validated: false,
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "IFQ1",
          shortTitle: "subjectOutsideIndependence",
          numberText: "1",
          text: "Activities Outside the Home",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Completely independent and active",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Doing less or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Doing much less or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ2",
          shortTitle: "subjectGroomingIndependence",
          numberText: "2",
          text: "Bathing, Grooming, and Hygiene",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Completely independent and healthy",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Doing <b><u>less</u></b> or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Doing much less or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if to do left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ3",
          shortTitle: "subjectHomeIndependence",
          numberText: "3",
          text: "Home, Life, and Hobbies",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Completely independent and active",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Doing less or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Doing much less or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ4",
          shortTitle: "subjectTechnologyIndependence",
          numberText: "4",
          text: "Phone, Remote Control, and Computer",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — No uncommon or repeated problems",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Using less or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Using <b><u>much less</u></b> or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "<b><u>Dependent on others</u></b> for help most of the time",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ5",
          shortTitle: "subjectMemoryIndependence",
          numberText: "5",
          text: "Memory",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — No significant forgetfulness",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Has forgetfulness but it <b><u>does not limit</u></b> activities",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Has forgetfulness that <b><u>limits activities</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Has <b><u>little to no</u></b> short-term memory",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ6",
          shortTitle: "subjectTransportIndependence",
          numberText: "6",
          text: "Driving or Public Transportation",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Completely independent",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Doing <b><u>less</u></b> or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Doing <b><u>much less</u></b> or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ7",
          shortTitle: "subjectOrientationIndependence",
          numberText: "7",
          text: "Orientation",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — No uncommon or repeated problems",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Some difficulty with date, day, time",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Some difficulty with time <b><u>and place/location</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Dependent on others — commonly disoriented",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ8",
          shortTitle: "subjectMedicationIndependence",
          numberText: "8",
          subText: "",
          helpText: "",
          displayType: "button",
          text: "Medication Management",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Independent in getting/taking meds",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Doing <b><u>less</u></b> or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Doing much less or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ9",
          shortTitle: "subjectDecisionIndependence",
          numberText: "9",
          text: "Making Decisions",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality to advance to the next question.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Completely independent and confident",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0.5",
              text: "Doing <b><u>less</u></b> or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Doing <b><u>much less</u></b> or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "IFQ10",
          shortTitle: "subjectFinancialIndependence",
          numberText: "10",
          text: "Money Management",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Please select the answer that matches your current level of functionality then press finish to complete this assessment.",
          answerOptions: [
            {
              value: "0",
              text: "Normal — Completely independent",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "0.5",
              text: "Doing <b><u>less</u></b> or needs some help <b><u>occasionally</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "1",
              text: "Doing <b><u>much less</u></b> or needs help <b><u>frequently</u></b>",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "2",
              text: "Doing <b><u>very little</u></b> or unsafe if left alone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: [
        {
          scoreTitle: "Independent Function Score",
          scoreMin: "0",
          scoreMax: "20",
          finalResult: null,
          multiSelectText: "false",
          isDefault: true,
          algorithm: [
            {
              operation: "add",
              values: [
                "IFQ1.answerValue",
                "IFQ2.answerValue",
                "IFQ3.answerValue",
                "IFQ4.answerValue",
                "IFQ5.answerValue",
                "IFQ6.answerValue",
                "IFQ7.answerValue",
                "IFQ8.answerValue",
                "IFQ9.answerValue",
                "IFQ10.answerValue",
              ],
            },
          ],
        },
      ],
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "IndependentFunction",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
